import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { ProductDetailsTabsEnum } from '@common/enums/product-details-tabs.enum';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VotingGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const { tab, id, voting_session_identifier } = route.queryParams;

    if (!id && !tab && !voting_session_identifier) {
      return true;
    }

    if (id) {
      let redirectPath: string = `dashboard/product/${id}`;

      if (tab === ProductDetailsTabsEnum.VOTING_SESSIONS) {
        if (voting_session_identifier) {
          redirectPath = `dashboard/product/${id}/voting-session/${voting_session_identifier}`;
        } else {
          redirectPath = `dashboard/product/${id}/voting`;
        }
      }

      this.router.navigate([redirectPath]);

      return false;
    }

    return true;
  }
}
